var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWave(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "visual",
    viewBox: "0 0 900 100",
    width: 900,
    height: 100,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 900,
    height: 100,
    fill: "#4ab0fb"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 43L9.3 44C18.7 45 37.3 47 56.2 49.7C75 52.3 94 55.7 112.8 57.3C131.7 59 150.3 59 169 56.5C187.7 54 206.3 49 225 47.2C243.7 45.3 262.3 46.7 281.2 45.8C300 45 319 42 337.8 42.2C356.7 42.3 375.3 45.7 394 48.7C412.7 51.7 431.3 54.3 450 52.7C468.7 51 487.3 45 506.2 45C525 45 544 51 562.8 53.5C581.7 56 600.3 55 619 55.8C637.7 56.7 656.3 59.3 675 57.8C693.7 56.3 712.3 50.7 731.2 48.3C750 46 769 47 787.8 49.8C806.7 52.7 825.3 57.3 844 56.8C862.7 56.3 881.3 50.7 890.7 47.8L900 45L900 101L890.7 101C881.3 101 862.7 101 844 101C825.3 101 806.7 101 787.8 101C769 101 750 101 731.2 101C712.3 101 693.7 101 675 101C656.3 101 637.7 101 619 101C600.3 101 581.7 101 562.8 101C544 101 525 101 506.2 101C487.3 101 468.7 101 450 101C431.3 101 412.7 101 394 101C375.3 101 356.7 101 337.8 101C319 101 300 101 281.2 101C262.3 101 243.7 101 225 101C206.3 101 187.7 101 169 101C150.3 101 131.7 101 112.8 101C94 101 75 101 56.2 101C37.3 101 18.7 101 9.3 101L0 101Z",
    fill: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "miter"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWave);
export default __webpack_public_path__ + "static/media/wave.ae6f8b962a8436d998b8d7d61d9a6c14.svg";
export { ForwardRef as ReactComponent };